import { createContext, useState, useEffect, useRef } from 'react';

import { defaultApiClient, defaultLogger } from '../apiClients/apiClient';
import { getOSLegacy, getMobileOS, detectOS } from '../analytics/deviceDetails';

// import { setUpNotificationListeners } from "@/core/notifications/main";

// import useLocation from "@/hooks/useLocation";

const deviceLocationUpdateIntervalDuration = 25_000;
const userInteractionStateUpdateInterval = 1_500;

const AppStateContext = createContext(null);

function AppStateContextProvider({ children }) {
    const notificationListenersCombinedUnsubscribeRef = useRef(null);
    const previousUserCurrentRideRef = useRef(null);

    // const { getDeviceLocation } = useLocation();

    const [deviceLocation, setDeviceLocation] = useState({
        latitude: 0,
        longitude: 0,
    });
    const [deviceLocationName, setDeviceLocationName] = useState('Searching ...');
    const [deviceFcmToken, setDeviceFcmToken] = useState(null);
    const [deviceFcmTokenSentToBackend, setDeviceFcmTokenSentToBackend] = useState(null);
    const [user, setUser] = useState(null);
    const [userCurrentRide, setUserCurrentRide] = useState(null);
    const [lastCompletedRideDetails, setLastCompletedRideDetails] = useState(null);

    // const fetchCurrentDeviceLocationAndSendUpdateToBackend = async () => {
    //   const { location, error } = await getDeviceLocation();
    //   if (location === null || (error !== null && error !== undefined)) {
    //     defaultLogger.debug("Failed to get device location.", {
    //       location: location,
    //       error: error,
    //       parentClass: "AppStateContextProvider",
    //       functionName: "fetchCurrentDeviceLocationAndSendUpdateToBackend",
    //     });
    //     setDeviceLocation({
    //       latitude: 42.42,
    //       longitude: 42.42,
    //     });
    //     return;
    //   }

    //   setDeviceLocation({
    //     latitude: location.coords.latitude,
    //     longitude: location.coords.longitude,
    //   });

    //   const updateUserCurrentLocationResponse = await defaultApiClient.methods.core.patchUserCurrentLocation({
    //     latitude: location.coords.latitude,
    //     longitude: location.coords.longitude,
    //   });
    //   if (!updateUserCurrentLocationResponse.success) {
    //     defaultLogger.debug("Failed to send location update to backend.", {
    //       updateUserCurrentLocationResponse: updateUserCurrentLocationResponse,
    //       parentClass: "AppStateContextProvider",
    //       functionName: "fetchCurrentDeviceLocationAndSendUpdateToBackend",
    //     });
    //     return;
    //   } else {
    //     console.log("updated user location successfully");
    //   }
    // };

    const fetchUserInteractionState = async () => {
        const getUserAndCurrentRideResponse =
            await defaultApiClient.methods.core.getUserInteractionState();
        if (!getUserAndCurrentRideResponse.success) {
            defaultLogger.debug('Failed to fetchUserInteractionState from backend.', {
                getUserAndCurrentRideResponse: getUserAndCurrentRideResponse,
                parentClass: 'AppStateContextProvider',
                functionName: 'fetchUserInteractionState',
            });
            return;
        }

        const nextUserCurrentRide = getUserAndCurrentRideResponse.result.userCurrentRide;
        const previousUserCurrentRide = previousUserCurrentRideRef.current;

        setUser(getUserAndCurrentRideResponse.result.user);
        setUserCurrentRide(nextUserCurrentRide);

        if (previousUserCurrentRide !== null && nextUserCurrentRide === null) {
            const latestCompletedRideResponse =
                await defaultApiClient.methods.core.getLatestCompletedRide();
            if (latestCompletedRideResponse.success) {
                setLastCompletedRideDetails(latestCompletedRideResponse.result.latestCompletedRide);
            }
        } else if (nextUserCurrentRide !== null) {
            setLastCompletedRideDetails(null);
        }

        previousUserCurrentRideRef.current = nextUserCurrentRide;
    };

    const registerStartUpAnalyticsEvents = async () => {
        const getOSLegacyResult = getOSLegacy();
        const getMobileOSResult = await getMobileOS();
        const detectOSResult = await detectOS();

        const deviceDetails = {
            getOSLegacyResult: getOSLegacyResult,
            getMobileOSResult: getMobileOSResult,
            detectOSResult: detectOSResult,
        };

        const registerDeviceDetailsEventResponse =
            await defaultApiClient.methods.analytics.registerDeviceDetailsEvent(deviceDetails);
        if (!registerDeviceDetailsEventResponse.success) {
            const responseErrorJsonStr = JSON.stringify(registerDeviceDetailsEventResponse.error);
            console.log(
                `API_CALL_FAILED: registerStartUpAnalyticsEvents.registerDeviceDetailsEventResponse; errorJsonStr = ${responseErrorJsonStr}`
            );
        }
    };

    // const setUpNotificationListenersUsingHook = async () => {
    //   const { fcmToken, unsubscribe, fcmTokenSentToBackend } = await setUpNotificationListeners();
    //   console.log(fcmTokenSentToBackend);

    //   setDeviceFcmToken(fcmToken);
    //   setDeviceFcmTokenSentToBackend(fcmTokenSentToBackend);
    //   notificationListenersCombinedUnsubscribeRef.current = unsubscribe;
    // };

    useEffect(() => {
        // setUpNotificationListenersUsingHook();

        // const deviceLocationUpdateIntervalId = setInterval(
        //   fetchCurrentDeviceLocationAndSendUpdateToBackend,
        //   deviceLocationUpdateIntervalDuration
        // );
        const userAndCurrentRideUpdateIntervalId = setInterval(
            fetchUserInteractionState,
            userInteractionStateUpdateInterval
        );

        // fetchCurrentDeviceLocationAndSendUpdateToBackend();
        fetchUserInteractionState();

        registerStartUpAnalyticsEvents();

        return () => {
            // clearInterval(deviceLocationUpdateIntervalId);
            clearInterval(userAndCurrentRideUpdateIntervalId);

            if (notificationListenersCombinedUnsubscribeRef.current) {
                notificationListenersCombinedUnsubscribeRef.current();
            }
        };
    }, []);

    return (
        <AppStateContext.Provider
            value={{
                deviceLocation: deviceLocation,
                deviceLocationName: deviceLocationName,
                setDeviceLocationName: setDeviceLocationName,
                deviceFcmToken: deviceFcmToken,
                deviceFcmTokenSentToBackend: deviceFcmTokenSentToBackend,
                user: user,
                userCurrentRide: userCurrentRide,
                fetchUserInteractionState: fetchUserInteractionState,
                lastCompletedRideDetails: lastCompletedRideDetails,
                setLastCompletedRideDetails: setLastCompletedRideDetails,
            }}
        >
            {children}
        </AppStateContext.Provider>
    );
}

export default AppStateContextProvider;
export { AppStateContext };
